export default "__VITE_ASSET__CHsnwQGi__"